var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:[
    'button',
    {
      [`button--${_vm.theme}`]: _vm.theme,
      'button--fullWidth': _vm.fullWidth,
      'button--inlineTextButton': _vm.isInlineTextButton,
      'button--smallHeight': _vm.smallHeight,
      'button--mobileSmallHeight': _vm.mobileSmallHeight,
      'button--basketButton': _vm.isBasketButton,
      'button--smallBasketButton': _vm.isSmallBasketButton,
      'button--smallCartDropdown': _vm.isSmallDropdownButton,
    },
  ],attrs:{"disabled":_vm.disabled,"to":_vm.to,"href":_vm.href,"type":_vm.tag === 'button' ? 'button' : ''},on:{"click":_vm.onClick}},[(_vm.isLoading)?[_c('svg',{staticClass:"button__loader",attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","x":"0px","y":"0px","viewBox":"0 0 100 100","enable-background":"new 0 0 0 0","xml:space":"preserve"}},[_c('path',{attrs:{"d":"M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"}},[_c('animateTransform',{attrs:{"attributeName":"transform","attributeType":"XML","type":"rotate","dur":"1s","from":"0 50 50","to":"360 50 50","repeatCount":"indefinite"}})],1)])]:[(_vm.hasHtml)?_c('span',{staticClass:"button__inner"},[_vm._t("default")],2):[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")]]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }